import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const useMediaSizes = () => {
	const theme = useTheme();

	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true
	});
	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true
	});

	return [isXs, isSm, isMd];
};

export default useMediaSizes;
